<template>
<!-- Dropdown with Freetext option, means user can add individual options -->
    <v-combobox
        v-model="selected"
        :items="options"
        :label="label"
        :multiple="multiple"
        clearable
        class="ml-4 mr-4"
        :alvqa="alvqa"
    >
        <template v-slot:selection="{ item, index }">
            <span v-if="index === 0" :alvqa="alvqa + '-selection'">
                <span v-if="checkIfString(item)">{{ item }}</span>
                <span v-else>{{ $t(item.text) }}</span>
            </span>
            <span v-if="index === 1" :alvqa="alvqa + '-selection'"> (+{{ selected.length - 1 }} {{$t('lang_GENERIC_CAPTION_OTHERS')}})</span>
        </template>
        <template v-slot:item="{ item }">
            <div :alvqa="alvqa + '-dropdown-' + item.value">
                <span v-if="checkIfString(item)">{{ item }}</span>
                <span v-else>{{ $t(item.text) }}</span>
            </div>
        </template>
    </v-combobox>
</template>

<script>
import VCombobox from 'vuetify/es5/components/VCombobox'

export default {
    name: "BaseEditPageCombobox",
    extends: VCombobox,
    props: {
        context: String,
        field: String,
        alvqa: {
            type: String,
            default: ''
        },
    },
    computed: {
        selected: {
            get() { return this.$store.getters['get'+this.context+'Details'+this.field] },
            set(selected) { this.$store.commit('set'+this.context+'Details'+this.field, selected) }
        },
        options() {
            return this.$store.getters['get'+this.context+this.field+'Options']
        }
    },
    methods: {
        checkIfString(item) { return typeof item === "string" ? true : false },
    }
}
</script>